import { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
// Components
import ListingActionBar from 'src/Components/ListingDetails/ListingActionBar'
// Styles
import styles from './Header.module.scss'

export interface HeaderProps {
  index: number;
  listing: { thumbnailImageFileNames: Array<string> };
  showTourButton?: boolean;
}

const Header = ({ index, listing, showTourButton }: HeaderProps) => {
  const PhotoCount = useCallback(
    ({ }: HeaderProps) => (
      <span className={styles.imageIndex} data-qa='image-index'>
        <FormattedMessage
          id='HomeSearch.listingDetails.imageIndex'
          defaultMessage='{index} of {total}'
          values={{
            index,
            total: listing.thumbnailImageFileNames.length,
          }}
        />
      </span>
    ),
    [index, listing]
  )

  return (
    <ListingActionBar
      showTourButton={showTourButton}
      headingComponent={PhotoCount}
      listing={listing}
    />
  )
}

export default Header
